/* eslint-disable @typescript-eslint/no-unused-vars */
import { CommonTable } from "../common/common-list/table/Table";
import { KTCard } from "../../../../_metronic/helpers";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pagination } from "../common/common-list/components/pagination/Pagination";
import { setId } from "../../../../redux/features/shared/sharedSlice";
import { EmployeeModal } from "./EmployeeModal";
import './style.scss';
import { UserListHeader } from "../common/common-list/components/header/UserListHeader";
import { EmployeeDetailsModal } from "./EmployeeDetailsModal";
import { employeeColumns } from "../common/common-list/table/columns/_employeeColumns";
import { getEmployees } from "../../../../redux/features/employee/_employeeAction";

const EmployeeList = () => {
  const sharedActions = useSelector((state: any) => state.sharedActions);
  const dispatch: any = useDispatch();
  const data: any = useSelector((state: any) => state.employeesList?.data)||[];
  const totalRecord  = useSelector((state: any) => state.employeesList?.totalRecord);

  useEffect(() => {
    dispatch(setId('Employee'))
    dispatch(getEmployees({ page: 1, limit: 10, sortOrder: sharedActions.sort }));
  }, [dispatch, sharedActions.sort]);

  const handleClick = (page: number) => {
    dispatch(getEmployees({ page: page, limit: 10, sortOrder: sharedActions.sort }));
  };

  return (
    <>
      <KTCard>
        <UserListHeader />
        <CommonTable data={data} columns={employeeColumns} />
        {sharedActions.employeeStatusModal && <EmployeeModal />}
        {sharedActions.employeeShowDetailsModal && <EmployeeDetailsModal /> }
        {totalRecord > 10 && <Pagination
          totalRecord={totalRecord}
          handleClick={handleClick}
        />}
      </KTCard>
    </>
  );
};

export { EmployeeList };
